





















































































































































































import { Component, Vue } from "vue-property-decorator";
import InjectionAuditService from "@/services/InjectionAuditService";
import InjectionAuditChecklist from "./InjectionAuditChecklist.vue";
import InjectionAuditDetail from "./InjectionAuditDetail.vue";
import UnitRuangPicker, { UnitRuangOption } from "@/components/common/UnitRuangPicker.vue";
import moment from "moment";

@Component({
  components: { InjectionAuditChecklist, InjectionAuditDetail, UnitRuangPicker }
})
export default class InjectionAuditList extends Vue {
  mode: "list" | "create" | "checklist" | "detail" = "list";
  currentSessionId = 0;

  sessions: any[] = [];
  loading = false;
  creating = false;

  filterTglDari = "";
  filterTglSampai = "";
  filterStatus: string | null = null;
  filterKategori: string | null = null;
  filterKritikal = false;
  filterNsi = false;

  form: any = this.emptyForm();

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "TTD Auditor", value: "submitted" },
    { text: "TTD Ka. Unit", value: "approved_ka_unit" },
    { text: "TTD Ka. Tim PPI", value: "approved_ka_ppi" },
    { text: "Disetujui Pimpinan", value: "approved_pimpinan" },
    { text: "Closed", value: "closed" }
  ];

  kategoriOptions = [
    { text: "Baik (≥85%)", value: "baik" },
    { text: "Intermediate (75-84%)", value: "intermediate" },
    { text: "Minimal (<75%)", value: "minimal" }
  ];

  periodeOptions = [
    { text: "Bulanan", value: "bulanan" },
    { text: "Triwulanan", value: "triwulanan" },
    { text: "Tahunan", value: "tahunan" },
    { text: "Sewaktu / Ad-hoc", value: "sewaktu" }
  ];

  shiftOptions = [
    { text: "Pagi", value: "pagi" },
    { text: "Sore", value: "sore" },
    { text: "Malam", value: "malam" }
  ];

  bulanOptions = [
    { text: "Januari", value: 1 }, { text: "Februari", value: 2 }, { text: "Maret", value: 3 },
    { text: "April", value: 4 }, { text: "Mei", value: 5 }, { text: "Juni", value: 6 },
    { text: "Juli", value: 7 }, { text: "Agustus", value: 8 }, { text: "September", value: 9 },
    { text: "Oktober", value: 10 }, { text: "November", value: 11 }, { text: "Desember", value: 12 }
  ];

  profesiOptions = [
    { text: "Dokter", value: "dokter" },
    { text: "Perawat", value: "perawat" },
    { text: "Bidan", value: "bidan" },
    { text: "Nakes Lain", value: "nakes_lain" },
    { text: "Petugas Penunjang", value: "petugas_penunjang" }
  ];

  headers = [
    { text: "No. Formulir", value: "nomor_formulir", width: 140 },
    { text: "Tgl. Audit", value: "tanggal_audit", width: 100 },
    { text: "Unit", value: "unit_nama" },
    { text: "Auditor", value: "auditor_nama" },
    { text: "Kepatuhan", value: "persen_kepatuhan", width: 100, align: "center" },
    { text: "Kategori", value: "kategori_kepatuhan", width: 140 },
    { text: "Status", value: "status", width: 180 },
    { text: "Flag", value: "flags", width: 70, align: "center", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, width: 110 }
  ];

  created() {
    this.loadData();
  }

  emptyForm() {
    return {
      unit_id: "",
      unit_nama: "",
      periode_audit: "bulanan",
      periode_tahun: new Date().getFullYear(),
      periode_bulan: new Date().getMonth() + 1,
      periode_triwulan: Math.ceil((new Date().getMonth() + 1) / 3),
      tanggal_audit: moment().format("YYYY-MM-DD"),
      shift: "pagi",
      jumlah_petugas_diobservasi: 5,
      jumlah_tindakan_diobservasi: 5,
      target_profesi: [],
      auditor_nip: "",
      auditor_jabatan: "",
      auditor_str_sip: ""
    };
  }

  async loadData() {
    this.loading = true;
    try {
      const params: any = {};
      if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
      if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
      if (this.filterStatus) params.status = this.filterStatus;
      if (this.filterKategori) params.kategori_kepatuhan = this.filterKategori;
      if (this.filterKritikal) params.ada_temuan_kritikal = 1;
      if (this.filterNsi) params.ada_adverse_event = 1;

      const res = await InjectionAuditService.getList(params);
      this.sessions = res.data.data.data || res.data.data || [];
    } catch (e) {
      // handled by ErrorAlert
    }
    this.loading = false;
  }

  onUnitChange(unit: UnitRuangOption | null) {
    this.form.unit_nama = unit ? unit.nama : "";
  }

  openCreate() {
    this.form = this.emptyForm();
    this.mode = "create";
  }

  async createSession() {
    if (!this.form.unit_id) {
      alert("Pilih unit / ruangan terlebih dahulu");
      return;
    }
    if (!this.form.tanggal_audit) {
      alert("Tanggal audit wajib diisi");
      return;
    }
    this.creating = true;
    try {
      const res = await InjectionAuditService.create(this.form);
      const session = res.data.data;
      this.currentSessionId = session.id;
      this.mode = "checklist";
    } catch (e) {
      // handled
    }
    this.creating = false;
  }

  openChecklist(item: any) {
    this.currentSessionId = item.id;
    this.mode = "checklist";
  }

  openDetail(item: any) {
    this.currentSessionId = item.id;
    this.mode = "detail";
  }

  returnToList() {
    this.mode = "list";
    this.currentSessionId = 0;
    this.loadData();
  }

  printPdf(id: number) {
    InjectionAuditService.printPdf(id);
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD-MM-YYYY") : "-";
  }

  getComplianceColor(rate: number) {
    if (rate >= 85) return "green";
    if (rate >= 75) return "orange";
    return "red";
  }
}
